/* eslint-disable @typescript-eslint/no-explicit-any */
import { useDispatch } from "react-redux";
import { setAccessRequestFilter } from "../index";

export const useAccessRequestFilterActions = () => {
  const dispatch = useDispatch();
  const updateFilter: any = ({ key, value }: { key: string; value: any }) =>
    dispatch(setAccessRequestFilter({ key, value }));

  return { updateFilter };
};
